import React from "react";
import { useTranslation } from 'react-i18next';


import ImgeasyIntegration from "../../../../assets/dataManagement/easyIntegration.png";

import "../easyIntegration/easyIntegration.scss";


const MergeData = () => {
    const { t } = useTranslation()
    return (
        <div className='container-transform-data container-easy-integration'>
            <div className='img-easy-integration'>
                <img src={ImgeasyIntegration} alt="" />
            </div>
            <div className='texts-easy-integration'>
                <h1>{t("data_management.merge_data.title")}</h1>
                <p>{t("data_management.merge_data.section_text_1")}</p>
                <p>{t("data_management.merge_data.section_text_2")}</p>
            </div>
        </div>
    )
}

export default MergeData